import { styled } from "styled-components";

import { colors } from "components";

export const ContainerAllFilter = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  background-color: ${colors.neutral_white};
`;

export const ContainerFormFilter = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
`;

export const ContainerFormFilterSwitch = styled.div`
  margin-bottom: 12px;
  display: flex;
  margin-top: 20px;
  margin-left: -9px;
`;

export const SimpleDropDownDiv = styled.div`
  width: 100%;
  margin-top: 4px;
`;

export const ContainerAutoComplete = styled.div`
  width: 100%;
  margin-top: 4px;

  .MuiAutocomplete-root {
    .MuiFormControl-root {
      margin-top: 0 !important;

      .MuiAutocomplete-inputRoot {
        padding: 11px 4px 9.9px 7px !important;
        width: 100% !important;
      }
    }
  }
`;

export const ContainerTwoComponents = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;
  padding-top: 20px;
`;

export const RadioBoxContainer = styled.div`
  margin-top: 18px;
  padding: 0 12px;
  border: 2px dashed #d1dbe3;
  border-radius: 4px;
`;

export const RadioBoxContainerBottom = styled.div`
  margin-top: 8px;
  margin-bottom: 16px;
  padding: 0 12px;
  border: 2px dashed #d1dbe3;
  border-radius: 4px;
`;

export const DateInputWrapper = styled.div`
  margin-top: 12px;
`;
